import { isSuperAdmin } from '@lumapps/permissions';

export const canAccessDomainsManagement = isSuperAdmin;
